import React from 'react';

function DomainTabs() {
    return (
        <div className="domain-tabs">
            <ul className="tab-list">
                <li className="tab-item"><a href="">All</a></li>
                <li className="tab-item active"><a href="">Academy</a></li>
                <li className="tab-item"><a href="">Website</a></li>
                <li className="tab-item"><a href="">Blog</a></li>
                <li className="tab-item"><a href="">TechDocs</a></li>
            </ul>
        </div>
    );
}

export default DomainTabs;


// WEBPACK FOOTER //
// ./src/components/DomainTabs.js